/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { Drawer, Box, styled, Typography, Divider, IconButton, Button, Collapse, FormGroup, FormControlLabel, Checkbox, TextField, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { apiRequest } from '../../../common/common';
import { showNotification } from '../../../common/Notification/ToastifyNotification';
import { LoadingPage } from '../../../common/LoadingPage';
import { EnterpriseAccess } from '../../../common/const';

const DemoBox1 = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 60
}));

const CustomFilterPanelWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: 10,
});

// The content area where filter controls will go
const FilterContent = styled(Box)({
    flexGrow: 1,         // Take up available space
    overflowY: 'auto',   // Enable scrolling if content overflows
    paddingBottom: 30,   // Ensure space for the fixed footer
    paddingTop: 10
});

// Footer area with fixed button
const FilterFooter = styled(Box)({
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    gap: 5
});

// Fixed button in the footer
const FixedButton = styled(Button)({
    width: '100%',
});

export default function CommonCopy({
    open,
    setOpen,
    selectedItem,
    selectedData,
    getData
}) {
    const { user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const currentPlanId = user?.organization?.Subscriptions[0]?.plan_id;
    const [searchingText, setSearchText] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);
    const [selectedRoom, setSelectedRoom] = useState([]);
    const [selectedDep, setSelectedDep] = useState([]);
    const [publicTemplate, setPublicTemplate] = useState([]);
    const [organizationTemplate, setOrganizationTemplate] = useState([]);
    const [privateTemplate, setPrivateTemplate] = useState([]);
    const templates = [
        ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && {
            label: "Mvedas",
            key: "public",
            data: publicTemplate,
        },
        (['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) || EnterpriseAccess === currentPlanId) && {
            label: "Organization",
            key: "organization",
            data: organizationTemplate,
        },
        {
            label: "Personal",
            key: "personal",
            data: privateTemplate,
        },
    ];

    const [toggleStates, setToggleStates] = useState(
        templates.reduce((acc, template) => {
            acc[template.label] = { open: false, nested: {} };
            return acc;
        }, {})
    );

    const handleClose = () => {
        setOpen(false);
        setPublicTemplate([]);
        setPrivateTemplate([]);
        setOrganizationTemplate([]);
        setSelectedRoom([]);
        setSelectedDep([]);
    }

    const handleSubmit = async () => {
        if (selectedData?.length > 0) {
            if (selectedRoom.length > 0) {
                setDataLoading(true);
                try {
                    const response = await apiRequest('post', '/template//copy-items', {
                        "itemIds": selectedData?.toString(),
                        "roomIds": selectedRoom?.map((a) => a.room_template_id)?.toString(),
                        "organization_id": user?.organization?.organization_id
                    });
                    if (response.data) {
                        handleClose();
                        getData(1, 'personal');
                        getData(1, 'public');
                        getData(1, 'organization');
                        showNotification(response.data.message, 'success');
                    }
                } catch (error) {
                    setDataLoading(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            } else {
                showNotification('Please select a room before copy item_templates', 'error');
            }
        } else {
            if (selectedDep.length > 0) {
                setDataLoading(true);
                try {
                    const response = await apiRequest('post', '/template/copy-rooms', {
                        "roomIds": selectedItem?.map((a) => a.room_template_id)?.toString(),
                        "deptTemplateIds": selectedDep?.map((a) => a.dept_template_id)?.toString(),
                        "organization_id": user?.organization?.organization_id,
                        "created_by": user?.user_id
                    });
                    if (response.data) {
                        handleClose();
                        getData(1, 'personal');
                        getData(1, 'public');
                        getData(1, 'organization');
                        showNotification(response.data.message, 'success');
                    }
                } catch (error) {
                    setDataLoading(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            } else {
                showNotification('Please select template for copy rooms', 'error');
            }
        }
    }

    const getInitialData = async (pageNo, key, searchText) => {
        setDataLoading(true);
        const url = [
            `/template/?userId=${user?.user_id}`,
            `organizationId=${user?.organization?.organization_id}`,
            `type=${key}`,
            `pageNo=${pageNo}`,
            `pageSize=100`,
            `${searchText ? `searchText=${searchText}` : ''}`
        ]
            .filter(Boolean)
            .join('&');
        try {
            const response = await apiRequest('get', url);
            const { data } = response.data;
            if (key === 'public') {
                setPublicTemplate(data?.sort((a, b) => a.department_name.localeCompare(b.department_name)));
            } else if (key === 'organization') {
                setOrganizationTemplate(data?.sort((a, b) => a.department_name.localeCompare(b.department_name)));
            } else {
                setPrivateTemplate(data?.sort((a, b) => a.department_name.localeCompare(b.department_name)));
            }
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    };

    const handleToggle = (label, key, nestedLabel) => {
        setToggleStates((prevState) => {
            const updatedState = { ...prevState };
            if (nestedLabel) {
                updatedState[label].nested[nestedLabel] = !updatedState[label].nested[nestedLabel];
            } else {
                updatedState[label].open = !updatedState[label].open;
                if (!updatedState[label].open) {
                    updatedState[label].nested = {};
                }
                if (prevState[label].open) {
                    getInitialData(1, key);
                }
            }
            return updatedState;
        });
    };

    return (
        <Drawer
            anchor="right"
            open={open}
            sx={{
                '& .MuiDrawer-paper': {
                    width: 350
                }
            }}
        >
            <CustomFilterPanelWrapper>
                {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                <DemoBox1>
                    <Typography variant='body1' style={{ fontWeight: 'bold' }}>Update Template</Typography>
                    <IconButton onClick={() => handleClose()}>
                        <ClearIcon />
                    </IconButton>
                </DemoBox1>
                <Divider />
                <FilterContent>
                    <Box style={{ padding: '1px 5px' }}>
                        <TextField
                            size="small"
                            id="outlined-search"
                            type="text"
                            placeholder="Search Templates"
                            style={{
                                background: '#ebeaea',
                            }}
                            fullWidth
                            value={searchingText}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    getInitialData(1, 'public', e.target.value);
                                    getInitialData(1, 'personal', e.target.value);
                                    getInitialData(1, 'organization', e.target.value);
                                    setToggleStates((prevState) => {
                                        const updatedState = { ...prevState };
                                        updatedState["Mvedas"].open = true;
                                        if (!updatedState["Mvedas"].open) {
                                            updatedState["Mvedas"].nested = {};
                                        }
                                        updatedState["Personal"].open = true;
                                        if (!updatedState["Personal"].open) {
                                            updatedState["Personal"].nested = {};
                                        }
                                        updatedState["Organization"].open = true;
                                        if (!updatedState["Organization"].open) {
                                            updatedState["Organization"].nested = {};
                                        }
                                        return updatedState;
                                    });
                                }
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    searchingText && (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => {
                                                    setSearchText('');
                                                    getInitialData(1, 'personal');
                                                }}
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                ),
                            }}
                        />
                    </Box>
                    {templates.map((template) => (
                        <div key={template.label}>
                            {template.label && (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <IconButton style={{ padding: 0 }} onClick={() => handleToggle(template.label, template.key)}>
                                        {toggleStates[template.label].open ? <ExpandMoreIcon /> : <KeyboardArrowRightIcon />}
                                    </IconButton>
                                    <span style={{ fontSize: '14px' }}>{template.label}</span>
                                </div>
                            )}
                            <Collapse in={toggleStates[template.label].open} timeout="auto" unmountOnExit>
                                {template.data?.map((a) => (
                                    <Box key={a.department_name} style={{ marginLeft: 15 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 10 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', width: '78%' }}>
                                                <IconButton style={{ padding: 0 }} onClick={() => handleToggle(template.label, a.key, a.department_name)}>
                                                    {toggleStates[template.label].nested[a.department_name] ? <ExpandMoreIcon /> : <KeyboardArrowRightIcon />}
                                                </IconButton>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                size="small"
                                                                indeterminate={selectedRoom?.filter((c) => c?.dept_template_id === a.dept_template_id)?.length > 0 ? selectedRoom?.filter((c) => c?.dept_template_id === a.dept_template_id)?.length < a?.room_templates?.length : false}
                                                                checked={[...selectedDep]?.some((c) => c.dept_template_id === a.dept_template_id)}
                                                            />}
                                                        label={<span style={{ fontSize: '14px' }}>{`${a.department_name} (${a?.room_templates?.reduce((sum, room) => sum + room.quantity, 0) || 0})`}</span>}
                                                        style={{ margin: 0 }}
                                                        onClick={(e) => {
                                                            const arr = [...selectedDep];
                                                            const newArr = [...selectedRoom];
                                                            if (e.target.checked) {
                                                                arr.push(a);
                                                                if (a.room_templates) {
                                                                    const roomArr = [
                                                                        ...newArr,
                                                                        ...a?.room_templates.map(template => ({
                                                                            ...template,
                                                                            dept_template_id: a.dept_template_id
                                                                        }))
                                                                    ];
                                                                    const uniqueArray = [
                                                                        ...new Set(
                                                                            roomArr.map((item) => JSON.stringify(item)),
                                                                        ),
                                                                    ].map((item) => JSON.parse(item));
                                                                    setSelectedRoom(uniqueArray);
                                                                }
                                                            } else {
                                                                const index = arr.findIndex((c) => a.dept_template_id === c.dept_template_id);
                                                                if (index > -1) {
                                                                    arr.splice(index, 1);
                                                                }
                                                                setSelectedRoom([...newArr]?.filter((c) => c?.dept_template_id !== a.dept_template_id));
                                                            }
                                                            setSelectedDep(arr);
                                                        }}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </div>
                                        <Collapse in={toggleStates[template.label].nested[a.department_name]} timeout="auto" unmountOnExit>
                                            {a.room_templates?.map((item) => (
                                                <Box key={item.room_name} style={{ marginLeft: 15 }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 10 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', width: '78%' }}>
                                                            <IconButton style={{ visibility: 'hidden', padding: 0 }}>
                                                                {toggleStates[template.label].nested[a.department_name] ? <ExpandMoreIcon /> : <KeyboardArrowRightIcon />}
                                                            </IconButton>
                                                            <FormGroup>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            size="small"
                                                                            checked={[...selectedRoom]?.some((a) => a?.room_template_id === item?.room_template_id)}
                                                                        />
                                                                    }
                                                                    label={<span style={{ fontSize: '14px' }}>{`${item.room_name} (${item?.item_templates?.reduce((sum, i) => sum + i.quantity, 0) || 0})`}</span>}
                                                                    style={{ margin: 0 }}
                                                                    onClick={(e) => {
                                                                        const arr = [...selectedRoom];
                                                                        if (e.target.checked) {
                                                                            item.dept_template_id = a.dept_template_id;
                                                                            arr.push(item);
                                                                        } else {
                                                                            const index = arr.findIndex((a) => a.room_template_id === item?.room_template_id);
                                                                            if (index > -1) {
                                                                                arr.splice(index, 1);
                                                                            }
                                                                        }
                                                                        setSelectedRoom(arr);
                                                                        const newArr = [...selectedDep];
                                                                        if (arr?.filter((c) => c.dept_template_id === a.dept_template_id)?.length === a?.room_templates?.length) {
                                                                            newArr.push(a);
                                                                        } else {
                                                                            const newIndex = newArr.findIndex((c) => c.dept_template_id === a.dept_template_id);
                                                                            if (newIndex > -1) {
                                                                                newArr.splice(newIndex, 1);
                                                                            }
                                                                        }
                                                                        setSelectedDep(newArr);
                                                                    }}
                                                                />
                                                            </FormGroup>
                                                        </div>
                                                    </div>
                                                </Box>
                                            ))}
                                        </Collapse>
                                    </Box>
                                ))}
                            </Collapse>
                        </div>
                    ))}
                </FilterContent>
                <FilterFooter>
                    <FixedButton variant="outlined" color="primary" onClick={() => handleClose()}>Cancel</FixedButton>
                    <FixedButton variant="contained" color="primary" onClick={() => handleSubmit()}>Save</FixedButton>
                </FilterFooter>
            </CustomFilterPanelWrapper>
        </Drawer>
    );
}